import React, {Component} from 'react';
import {
  Player,
  ControlBar,
  ReplayControl,
  PlayToggle,
  CurrentTimeDisplay,
  TimeDivider,
  VolumeMenuButton
} from 'video-react';

import './styles/feedback.scss';

export default class MainVideo extends Component {

  constructor() {
    super();

    this.state = {
      statusVideo: false,
      eventActivePlayer: false,
      mutedVideo: true,
    }
  }

  playVideoHandler() {
    this.setState({
      statusVideo: true,
    }, () => {
      this.player.video.play();
      this.player.subscribeToStateChange(this.handleVideoStateChange.bind(this));
    })
  }

  handleVideoStateChange(state, prevState) {
    if (state.paused && !prevState.paused && this.state.mutedVideo) {
      this.setState({
        mutedVideo: false,
      })
    }
  }

  render() {

    return(
      <div className="feedback">
        <div className="container-inner">
          <div className="feedback__title">
            <span>Coming soon</span>
            <p>We&nbsp;have big plans for the future of&nbsp;our fashion project. The line will be&nbsp;expanded with more seasonal items and accessories, and the second drop of&nbsp;the collection is&nbsp;already on&nbsp;its way.</p>
          </div>
          <div className="feedback__desc">
            <div className="feedback__desc__text">
              <p>Your contribution to&nbsp;this project is&nbsp;crucial. We&nbsp;would love to&nbsp;get your feedback on&nbsp;the first release and hear any ideas and proposals for our next drops. Find the feedback form in&nbsp;the footer below.</p>
            </div>
          </div>
        </div>
        <div className="feedback__video">
          <div className={`feedback__video__preview ${this.state.statusVideo ? '_hide' : ''}`} style={{ backgroundImage: `url(${require('../../static/images/gallery/image-14.jpg').default})` }}>
            <button className="feedback__video__play" onClick={this.playVideoHandler.bind(this)}></button>
          </div>
          <div className="feedback__video__main">
            <Player
              ref={(player) => { this.player = player }}
              playsInline
              // autoPlay
              loop
              muted={this.state.mutedVideo}
              preload="auto"
              poster={require('../../static/images/gallery/image-14.jpg').default}
            >
              <source src={require('../../static/video/karen-press.mp4').default} />

              <ControlBar>
                <PlayToggle />
                <ReplayControl disabled />
                <TimeDivider order={4.2} />
                <CurrentTimeDisplay order={4.1} />
                <VolumeMenuButton />
              </ControlBar>
            </Player>
          </div>
        </div>
      </div>
    )
  }
}